import { Slider as BaseSlider } from '@base-ui/react/slider';
import styles from './Slider.module.css';

interface ISliderProps {
  value: number;
  onValueChange: (value: number) => void;
  /** Fired on pointer-up / keyboard commit — use for the "settle" of a drag. */
  onValueCommitted?: (value: number) => void;
  min?: number;
  max?: number;
  step?: number;
  disabled?: boolean;
  ariaLabel: string;
}

/**
 * Single-value slider — thin wrapper over Base UI's headless Slider so the rest
 * of the app consumes one styled primitive (Components/ui convention). Base UI
 * yields a `number` for a scalar `value`; we keep the public API scalar.
 */
export function Slider({
  value,
  onValueChange,
  onValueCommitted,
  min = 0,
  max = 100,
  step = 1,
  disabled = false,
  ariaLabel,
}: ISliderProps) {
  return (
    <BaseSlider.Root
      value={value}
      onValueChange={(next) => onValueChange(Array.isArray(next) ? (next[0] ?? 0) : next)}
      onValueCommitted={
        onValueCommitted
          ? (next) => onValueCommitted(Array.isArray(next) ? (next[0] ?? 0) : next)
          : undefined
      }
      min={min}
      max={max}
      step={step}
      disabled={disabled}
      className={styles.root}
    >
      <BaseSlider.Control className={styles.control}>
        <BaseSlider.Track className={styles.track}>
          <BaseSlider.Indicator className={styles.indicator} />
          <BaseSlider.Thumb className={styles.thumb} aria-label={ariaLabel} />
        </BaseSlider.Track>
      </BaseSlider.Control>
    </BaseSlider.Root>
  );
}
